import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetDuplicateCandidatesQueryVariables = Types.Exact<{
  input: Types.DuplicateCandidatesInput;
}>;


export type GetDuplicateCandidatesQuery = { __typename?: 'Query', duplicateCandidates: { __typename?: 'DuplicateCandidatesPayload', checkPending: boolean, counts: Array<{ __typename?: 'DuplicateCandidateCounts', entityType: Types.DuplicateEntityType, open: number, dismissed: number, resolved: number }>, items: Array<{ __typename?: 'DuplicateCandidate', id: string, entityType: Types.DuplicateEntityType, source: Types.DuplicateCandidateSource, status: Types.DuplicateCandidateStatus, outcome?: Types.DuplicateCandidateOutcome | null, dismissedAt?: Types.TDateISO | null, dismissedBy?: string | null, resolvedAt?: Types.TDateISO | null, a: { __typename?: 'DuplicateRecordSummary', id: string, name: string, erpId?: string | null, historyCount: number }, b: { __typename?: 'DuplicateRecordSummary', id: string, name: string, erpId?: string | null, historyCount: number }, judgment: { __typename?: 'DuplicateJudgment', score: number, confidence: number, label: string, modelVersion: string, foundAt: Types.TDateISO }, flags: Array<{ __typename?: 'DuplicateFieldFlag', field: string, agrees: boolean, probability: number }> }>, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const GetDuplicateCandidatesDocument = new TypedDocumentString(`
    query GetDuplicateCandidates($input: DuplicateCandidatesInput!) {
  duplicateCandidates(input: $input) {
    checkPending
    counts {
      entityType
      open
      dismissed
      resolved
    }
    items {
      id
      entityType
      a {
        id
        name
        erpId
        historyCount
      }
      b {
        id
        name
        erpId
        historyCount
      }
      judgment {
        score
        confidence
        label
        modelVersion
        foundAt
      }
      flags {
        field
        agrees
        probability
      }
      source
      status
      outcome
      dismissedAt
      dismissedBy
      resolvedAt
    }
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetDuplicateCandidates: build.query<GetDuplicateCandidatesQuery, GetDuplicateCandidatesQueryVariables>({
      query: (variables) => ({ document: GetDuplicateCandidatesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetDuplicateCandidatesQuery, useLazyGetDuplicateCandidatesQuery } = injectedRtkApi;
